module.exports = __webpack_public_path__ + "static/media/ICON_QUICK_START_VIDEO.484e06ab.png";